// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"success-created-custom-modal_wrapper__RelRf"};